import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.932617 2.49935C0.932617 1.48683 1.75343 0.666016 2.76595 0.666016H6.93262C7.06523 0.666016 7.1924 0.718694 7.28617 0.812462L10.1195 3.6458C10.2133 3.73956 10.266 3.86674 10.266 3.99935V9.49935C10.266 10.5119 9.44516 11.3327 8.43262 11.3327H2.76595C1.75343 11.3327 0.932617 10.5119 0.932617 9.49935V2.49935ZM2.76595 1.66602C2.30571 1.66602 1.93262 2.03911 1.93262 2.49935V9.49935C1.93262 9.9596 2.30571 10.3327 2.76595 10.3327H8.43262C8.89288 10.3327 9.26595 9.95961 9.26595 9.49935V4.20646L6.72551 1.66602H2.76595Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.76595 0.832682C7.04209 0.832682 7.26595 1.05654 7.26595 1.33268V3.66602H9.59928C9.87543 3.66602 10.0993 3.88987 10.0993 4.16602C10.0993 4.44216 9.87543 4.66602 9.59928 4.66602H6.76595C6.48981 4.66602 6.26595 4.44216 6.26595 4.16602V1.33268C6.26595 1.05654 6.48981 0.832682 6.76595 0.832682Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.59928 8.16602C3.59928 7.88987 3.82314 7.66602 4.09928 7.66602H7.09928C7.37543 7.66602 7.59928 7.88987 7.59928 8.16602C7.59928 8.44216 7.37543 8.66602 7.09928 8.66602H4.09928C3.82314 8.66602 3.59928 8.44216 3.59928 8.16602Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.59928 6.16602C3.59928 5.88987 3.82314 5.66602 4.09928 5.66602H7.09928C7.37543 5.66602 7.59928 5.88987 7.59928 6.16602C7.59928 6.44216 7.37543 6.66602 7.09928 6.66602H4.09928C3.82314 6.66602 3.59928 6.44216 3.59928 6.16602Z"
      fill="currentColor"
    />
  </SvgIcon>
));
